export const HostUrl = process.env.REACT_APP_HOST_URL

export const clientInfo = {
    id : process.env.REACT_APP_REFRESH_CLIENT_ID,
    secret : process.env.REACT_APP_REFRESH_CLIENT_SECRET
}